import { useMutation, useQueryClient } from "react-query";
import { editScheduleLesson } from "api/services/schedule";
import { EScheduleQueryKeys } from "api/endpoints/schedule";
import { logError } from "utils/notifications";
import { TEditLessonBody, TLesson } from "types/api/lesson";
import { TApiError } from "types/api/error";

export const useEditScheduleLesson = () => {
  const queryClient = useQueryClient();
  return useMutation<TLesson, TApiError, TEditLessonBody>(editScheduleLesson, {
    onSuccess: () => {
      queryClient.invalidateQueries(EScheduleQueryKeys.getScheduleLessons);
    },
    onError: (error) => logError({ error }),
    retry: false,
  });
};
